import React from "react";
import MarketingIntegrationsZapier from "components/Marketing/Integrations/Zapier";
import Layout from "components/Layout";

const PagesFeaturesZapier = (props) => {
  return <Layout>{() => <MarketingIntegrationsZapier {...props} />}</Layout>;
};

export default PagesFeaturesZapier;
